upload_in_progress = false

Dropzone.autoDiscover = false

photoContainer = $('#photos_container').photoContainer()
layoutContainer = $('#layouts_container').layoutContainer()
backgroundsContainer = $('#backgrounds_container').backgroundsContainer()
shapesContainer = $('#shapes_container').shapesContainer()
textsContainer = $('#texts_container').textsContainer()
userShapesContainer = $('#user_shapes_container').userShapesContainer()
userPageContainer = $('#user_page_container').userPageContainer()
calendariumContainer = $('#calendarium_container').calendariumContainer()
themesContainer = $('#themes_content_container').themesContainer()
# themesContainerSmall = $('#themes_container').themesContainer()


@imagePreviewDelayed = ->
  timer = undefined
  timer_out = undefined
  delay = 750
  delay_out = 250

  ###CONFIG ###

  xOffset = 100
  yOffset = 30
  # these 2 variable determine popup's distance from the cursor
  # you might want to adjust to get the right result

  ###END CONFIG ###

  # console.log 'show'
  $(document).on 'mouseover', 'a.image_hover_preview_delayed', (e) ->

    # console.log $(@).parent().parent()

    if $(@).parent().parent().attr('id') == 'helper'
      return

    source = this
    timer = setTimeout ->
      source.t = source.title
      source.title = ''
      c = if source.t != '' then '<br/>' + source.t else ''
      $('body').append '<p id=\'image_hover_preview\'><img src=\'' + source.href + '\' alt=\'Image preview\' />' + c + '</p>'
      $('#image_hover_preview')
        .css('top', e.pageY - xOffset + 'px')
        .css('left', e.pageX + yOffset + 'px')
        .fadeIn 'fast'
      return
    , delay

  $(document).on 'mouseout', 'a.image_hover_preview_delayed', (e) ->
    clearInterval timer
    $('#image_hover_preview').remove()
    return
  

  $(document).on 'mousemove', 'a.image_hover_preview_delayed', (e) ->
    $('#image_hover_preview').css('top', e.pageY - xOffset + 'px').css 'left', e.pageX + yOffset + 'px'
    return
  return



imagePreviewDelayed()

check_error = ->
  $.ajax(
    dataType: 'JSON'
    method: 'POST'
    data:
      app_url: window.location.pathname
    url: '/ajax/app/check_errors/'
  ).done (check) ->
    console.log check


change_offset = (offset) ->
  showLoader()
  $.ajax(
    dataType: 'JSON'
    method: 'POST'
    data:
      offset: offset
      app_url: window.location.pathname
    url: '/ajax/app/change_calendarium_offset/'
  ).done (data) ->
      loadPage()
      return
    # console.log data

change_product_name = (name) ->
  loading()
  $.ajax(
    dataType: 'JSON'
    method: 'POST'
    data:
      product_name: name
      app_url: window.location.pathname
    url: '/ajax/app/change_product_name/'
  ).done (data) ->
      # loadPage()
      # 
      console.log data
      $('.frame.product_name img#product_name_img').attr('src', data.product_name);
      loading_stop()
      $("#product_name").focus()
      return
  return false

$(document).on 'submit', '#product_name_change', ->
  change_product_name($("#product_name").val())
  return false

change_product_save_name = (name) ->
  $.ajax(
    dataType: 'JSON'
    method: 'POST'
    data:
      product_name: name
      app_url: window.location.pathname
    url: '/ajax/app/change_product_save_name/'
  ).done (data) ->
      # loadPage()
      # 
      console.log data
      # $('.frame.product_name img#product_name_img').attr('src', data.product_name);
      loading_stop()
      # $("#product_name").focus()
      return
  return false


timer2 = {}
$(document).on 'keyup', '#product_save_name', ->
  clearInterval(timer2)
  name = $(@).val()
  timer2 = setTimeout ->
      console.log 'tajmouted'
      change_product_save_name($('#product_save_name').val())
      return
    , 400  


timer = {}
delay = 1750
$(document).on 'keyup', '#product_name', ->
  clearInterval(timer)
  name = $(@).val()
  timer = setTimeout ->
      console.log 'tajmouted'
      change_product_name(name)
      return
    , 800   

  return false;

$(document).on 'change', '#calendarium_offset', ->
  showLoader()
  $.ajax(
    dataType: 'JSON'
    method: 'POST'
    data:
      offset: $(@).val()
      app_url: window.location.pathname
    url: '/ajax/app/change_calendarium_offset/'
  ).done (data) ->
      loadPage()
      return
    # console.log data

  return false




$(document).on 'click', '.clear', ->
  showLoader()
  $.ajax(
    dataType: 'JSON'
    method: 'POST'
    data:
      app_url: window.location.pathname
      url: '/ajax/app/clear/'
  ).done (data) ->
    loadPage()
    photoContainer.reload()
    console.log data

  return false


autofill = (looping) -> 
  showLoader()
  $.ajax(
    dataType: 'JSON'
    method: 'POST'
    data:
      app_url: window.location.pathname
      loop: looping
    url: '/ajax/app/autofill/'
  ).done (data) ->
    loadPage()
    photoContainer.reload()
    console.log data

$(document).on 'click', '.auto', ->
  autofill($('select#loop').val())

  return false

cthulu = ->
  $.ajax(
    dataType: 'JSON'
    method: 'POST'
    data:
      app_url: window.location.pathname
    url: '/ajax/app/cthulu/'
  ).done (data) ->
    if data.reload
      loadPage()
    console.log data
  return   

$('#createPDF').click ->
  createPdf()
  return false

createPdf = ->
  # loading('Tvořím PDF', ['Ještě chvíli...', 'Už to bude...', 'Ještě chvilinku strpení...', 'Ještě kousek...', 'Ještě moment...', 'Ještě maličko...', 'Ještě pár vteřin...']);
  
  loading('Tvořím PDF', [
    'Ještě chvíli...',
    'Už to bude...',
    'Ještě chvilinku strpení...',
    'Ještě kousek...',
    'Ještě moment...',
    'Ještě maličko...',
    'Ještě pár vteřin...',
    'Ani Řím nepostavili za den...',
    'I Bůh tvořil svět sedm dní...',
    'Dokonalost potřebuje čas...',
    'Mistr tiskař si taky dává načas...',
    'Kvalita chce klid a kafe...',
    'Tiskneme, jak nejlépe umíme...',
    'Trpělivost růže přináší...',
    'PDF se samo nenarodí...',
    'Ještě pár bajtů do cíle...',
    'Data se srovnávají do latě...',
    'Sázej písmo, říkali... bude to sranda, říkali...',
    'Na dobré věci se čeká...',
    'Tvořím PDF s láskou a trpělivostí...',
    'Jeden pixel za druhým...',
    'Tohle by rozplakalo i procesor...',
    'Zatímco čekáš, PDF roste do krásy...',
    'V zákulisí to teď jiskří...',
    'Ještě drobná kouzla s fonty...',
    'Almost there... skoro!'
  ]);


  $.ajax(
      type: 'POST'
      dataType: 'JSON'
      data:
        app_url: window.location.pathname
      url: '/ajax/app/create_pdf/'
          
  ).done((data) ->
      loading_stop()
      $('#download_button').removeClass('hidden')
      $('#download_button').attr('href', data.pdf_url)
      

      console.log data
      return
  ).fail (jqXHR) ->
      console.warn 'Error: ' + jqXHR.responseText
      return


add2cart = ->
    # loading_stop()
    
    $.ajax(
        type: 'POST'
        dataType: 'JSON'
        url: '/ajax/get_t/'
            
    ).done((data) ->
        console.log data
        loading(data.app_loading1, [data.app_loading2, data.app_loading3, data.app_loading4])
    ).fail (jqXHR, textStatus) ->
        console.warn 'Error: ' + jqXHR.responseText
        return

    
    $.ajax(
      dataType: 'JSON'
      method: 'POST'
      data:
        app_url: window.location.pathname
      url: '/ajax/app/add2cart/'
    ).done((data) ->
        
        console.log data

        if data.localhost
          window.location.replace '/cart/'

        if data.status == true
          dataLayer.push
            'event': 'add_to_cart'
            'ecommerce': 
              'currencyCode': data.currency,
              'add':                              
                'products': [                     
                  'name': data.product_data.basket_name,
                  'id': data.product_data.id,
                  'price': (data.product_data.price / data.dph) / data.product_data.qty
                  'quantity': data.product_data.qty,
                 ]
            'eventCallback': ->
              # window.location.href = data.kosik  
              window.location.replace data.kosik
              return
          
          setTimeout ->
            window.location.replace data.kosik
            return
          , 1500
        
        else
          window.location.replace data.kosik
        return
    ).fail (jqXHR, textStatus) ->
        console.warn 'Error: ' + jqXHR.responseText
        return
    return   

save_product = ->
    $.ajax(
      dataType: 'JSON'
      method: 'POST'
      data:
        app_url: window.location.pathname
      url: '/ajax/app/save_product/'
    ).done((data) ->
        if data.status == true
            window.location.href = data.new_url
        return
    ).fail (jqXHR, textStatus) ->
        console.warn 'Error: ' + jqXHR.responseText
        return
    return   

calcPrice = ->
    $.ajax(
      dataType: 'JSON'
      method: 'POST'
      data:
        app_url: window.location.pathname
      url: '/ajax/app/calc_price/'
    ).done((data) ->
        console.log data
        param_update()
        return
    ).fail (jqXHR, textStatus) ->
        console.warn 'Error: ' + jqXHR.responseText
        return
    return  

param_update = ->
  if $('form#product_form').length == 0
    return false
  $.ajax(
    dataType: 'JSON'
    method: 'POST'
    data:
      app_url: window.location.pathname
      url: window.location.pathname
      product_params: $('form#product_form').serialize()
    url: '/ajax/app/param_update/'
  ).done((data) ->
      console.log data

      if $('input[name=qty][type=hidden]').length
        $('input[name=qty]').val data.qty

      reload_prices()

      

      return
  ).fail (jqXHR, textStatus) ->
      console.warn 'Error: ' + jqXHR.responseText
      return
  return  
  return false



$(document).ready ->

    loadPage()
    param_update()


    

    
    $(document).on 'click', '.delete_photo', ->
      photo_parent = $(@).parent('.outer_photo')
      $.ajax(
        dataType: 'JSON'
        method: 'POST'
        url: '/ajax/app/delete_photo/'
        data:
          app_url:window.location.pathname
          product_id: $(@).data 'product_id'
          filename: $(@).data 'filename'
      ).done((data) ->
        console.log data
        photo_parent.remove()

        # photoContainer.reload()
      )
      return false

    $('#product_form input[type=radio]').change ->
      param_update()
      return false

    $('#product_form input[type=text]').keyup ->
      param_update()
      return false

    $('#product_form select').change ->
      param_update()
      return false

    $(document).on 'click', '.quality_warning_ico',  ->
        $.ajax(
          dataType: 'JSON'
          method: 'POST'
          data:
            app_url: window.location.pathname
          url: '/ajax/app/get_t/'
        ).done (data) ->
          new swal(
              title: data.t.app30
              text: data.t.app31
              )
          return false

        return false


    $(document).on 'click', '.add2cart', ->

      loading()



      $.ajax(
        dataType: 'JSON'
        method: 'POST'
        data:
          app_url: window.location.pathname
        url: '/ajax/app/check_errors/'
      ).done (check) ->

        console.log check


        if !check.errors
          add2cart()

        if check.errors.empty_pages_book_die
          loading_stop()
          new swal(
            title: check.t.app102
            html: check.t.app103
            icon: 'info'
            # showCancelButton: true
            # showDenyButton: true
            confirmButtonColor: '#3DC132'
            confirmButtonText: check.t.souhlas2
            cancelButtonColor: '#5599FF'
            cancelButtonText: check.t.app81
            # denyButtonText: check.t.app80
            showCloseButton: true
          ).then (result) ->
            console.log result

            return false

        else if check.errors.total_empty
          loading_stop()
          new swal(
            title: check.t.app100
            html: check.t.app101
            icon: 'info'
            # showCancelButton: true
            # showDenyButton: true
            confirmButtonColor: '#3DC132'
            confirmButtonText: check.t.souhlas2
            cancelButtonColor: '#5599FF'
            cancelButtonText: check.t.app81
            # denyButtonText: check.t.app80
            showCloseButton: true
          ).then (result) ->
            console.log result

            return false


        else if check.errors.empty_pages_book
          loading_stop()
          new swal(
            title: check.t.app78
            html: check.t.app79
            icon: 'question'
            showCancelButton: true
            # showDenyButton: true
            confirmButtonColor: '#3DC132'
            confirmButtonText: check.t.app37
            cancelButtonColor: '#5599FF'
            cancelButtonText: check.t.app81
            # denyButtonText: check.t.app80
            showCloseButton: true
          ).then (result) ->
            console.log result

            if result.isDenied
              showLoader()
              
              $.ajax(
                dataType: 'JSON'
                method: 'POST'
                data:
                  app_url: window.location.pathname
                url: '/ajax/app/delete_last_pages/'
              ).done (data) ->
                
                add2cart()
                
                return false
            if result.isConfirmed
              add2cart()

            return false
            # if (result.value)
            #   add2cart()
            #   return

        else if check.errors.empty_pages
          loading_stop()
          new swal(
            title: check.t.app28
            html: check.t.app29
            icon: 'info'
            showCancelButton: true
            confirmButtonColor: '#3DC132'
            confirmButtonText: check.t.app37
            cancelButtonColor: '#5599FF'
            cancelButtonText: check.t.app38
            showCloseButton: true
          ).then (result) ->
            if (result.value)
              add2cart()
              return

        else if check.errors.moved
          loading_stop()
          new swal(
            title: check.t.app69
            html: check.t.app70
            icon: 'info'
            showCancelButton: true
            confirmButtonColor: '#3DC132'
            confirmButtonText: check.t.app71
            cancelButtonColor: '#5599FF'
            cancelButtonText: check.t.app72
            showCloseButton: true
          ).then (result) ->
            if (result.value)
              add2cart()
              return

        else if check.errors.quality
          loading_stop()
          new swal(
            title: check.t.app30
            html: check.t.app31
            icon: 'info'
            showCancelButton: true
            confirmButtonColor: '#3DC132'
            confirmButtonText: check.t.app39
            cancelButtonColor: '#5599FF'
            cancelButtonText: check.t.app40
            showCloseButton: true
          ).then (result) ->
            if (result.value)
              loading()
              add2cart()
              return
        else 
          # showLoader()
          add2cart()

      return false




    photoContainer.reload()

    uploaded_files = 0
    queed_files = 0

    uploader_background = $('#dropzone_backgrounds').dropzone


        timeout: 3600000
        init: ->  
            _this = this
            $("#background_upload_button").click ->
                _this.hiddenFileInput.click()
                return
            this.on 'success', (file, out) ->
                uploaded_files = uploaded_files + 1
                # $('.dz-preview').remove();
                return
            this.on 'addedfile', ->
                queed_files = queed_files + 1
                $('#main_progress').show()
                return
            # this.on 'chunksUploaded', (file, done) ->
            #   console.log file
            #   console.log done
            this.on 'complete', ->
                if this.getUploadingFiles().length == 0 && this.getQueuedFiles().length == 0
                    $('.dz-preview').remove();
                    backgroundsContainer.reload()
                    $('#main_progress #progress').css 'width', '0%'
                    $('#main_progress').hide()
                    queed_files = 0
                    uploaded_files = 0
                return
            this.on 'totaluploadprogress', (uploadProgress, totalBytes, totalBytesSent) ->
                $('#main_progress').show()
                # $('#main_progress #progress').css 'width', uploadProgress+'%'
                if uploaded_files > 0 
                  $('#main_progress #progress').css 'width', ((uploaded_files/queed_files) * 100)+'%'
                $('#progress_message').text (uploaded_files+1) + ' / ' + queed_files 

                # console.log uploadProgress, totalBytes, totalBytesSent
                return
            return

    uploader_shape = $('#dropzone_shapes').dropzone
        previewTemplate: '
            <div class="dz-preview dz-file-preview">
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
            </div>
        ',
        timeout: 3600000
        init: ->  
            _this = this
            $("#shape_upload_button").click ->
                _this.hiddenFileInput.click()
                return
            this.on 'success', (file, out) ->
                uploaded_files = uploaded_files + 1
                # $('.dz-preview').remove();
                return
            this.on 'addedfile', ->
                queed_files = queed_files + 1
                $('#main_progress').show()
                return
            # this.on 'chunksUploaded', (file, done) ->
            #   console.log file
            #   console.log done
            this.on 'complete', ->
                if this.getUploadingFiles().length == 0 && this.getQueuedFiles().length == 0
                    $('.dz-preview').remove();
                    userShapesContainer.reload()
                    $('#main_progress #progress').css 'width', '0%'
                    $('#main_progress').hide()
                    queed_files = 0
                    uploaded_files = 0
                return
            this.on 'totaluploadprogress', (uploadProgress, totalBytes, totalBytesSent) ->
                $('#main_progress').show()
                $('#main_progress #progress').css 'width', uploadProgress+'%'
                $('#progress_message').text uploaded_files + ' / ' + queed_files 

                # console.log uploadProgress, totalBytes, totalBytesSent
                return
            return

    uploader_add_page = $('#dropzone_add_new_page').dropzone
        previewTemplate: '
            <div class="dz-preview dz-file-preview">
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
            </div>
        ',
        timeout: 3600000
        params: 
            enhance: $('input[name=auto_enhance]').val()

        init: ->  
            _this = this
            $("#upload_button").click ->
                _this.hiddenFileInput.click()
                return

            this.on 'success', (file, out) ->
                uploaded_files = uploaded_files + 1
                # $('.dz-preview').remove();
                return
            this.on 'addedfile', ->
                queed_files = queed_files + 1
                $('#main_progress').show()
                return
            # this.on 'chunksUploaded', (file, done) ->
            #   console.log file
            #   console.log done
            this.on 'complete', ->
                if this.getUploadingFiles().length == 0 && this.getQueuedFiles().length == 0
                    $('.dz-preview').remove();
                    setTimeout ->
                      photoContainer.reload()
                      return
                    , 110
                    $('#main_progress #progress').css 'width', '0%'
                    $('#main_progress').hide()
                    queed_files = 0
                    uploaded_files = 0
                    if $('input[name=add_page]').val() == '1'
                      setTimeout ->
                        loadPage()
                        return
                      , 110
                return
            this.on 'totaluploadprogress', (uploadProgress, totalBytes, totalBytesSent) -> 
                $('#main_progress').show() if uploaded_files > 0 
                $('#main_progress #progress').css 'width', ((uploaded_files/queed_files) * 100)+'%' 
                $('#progress_message').text (uploaded_files+1) + ' / ' + queed_files      
                return
            return
    
    uploader = $('#dropzone_main').dropzone
        previewTemplate: '
            <div class="dz-preview dz-file-preview">
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
            </div>
        ',
        timeout: 3600000
        params: 
            enhance: $('input[name=auto_enhance]').val()

        init: ->  
            _this = this
            $("#upload_button").click ->
                _this.hiddenFileInput.click()
                return

            this.on 'success', (file, out) ->
                uploaded_files = uploaded_files + 1
                # $('.dz-preview').remove();
                return
            this.on 'addedfile', ->
                queed_files = queed_files + 1
                $('#main_progress').show()
                return
            # this.on 'chunksUploaded', (file, done) ->
            #   console.log file
            #   console.log done
            this.on 'complete', ->
                if this.getUploadingFiles().length == 0 && this.getQueuedFiles().length == 0
                    $('.dz-preview').remove();
                    setTimeout ->
                      photoContainer.reload()
                      return
                    , 110
                    $('#main_progress #progress').css 'width', '0%'
                    $('#main_progress').hide()
                    queed_files = 0
                    uploaded_files = 0
                    if $('input[name=add_page]').val() == '1'
                      setTimeout ->
                        loadPage()
                        return
                      , 110
                return
            this.on 'totaluploadprogress', (uploadProgress, totalBytes, totalBytesSent) ->
              $('#main_progress').show()
              $('#main_progress #progress').css 'width', uploadProgress + '%'
              $('#progress_message').text Math.round(uploadProgress) + '% (' + (uploaded_files + 2) + '/' + queed_files + ')'
              return
            return

 
    $('input[accept]').each ->
      $(@).removeAttr('accept')
      
    return

